import { createFileRoute } from "@tanstack/react-router";
import { ExpenseModals } from "@/components/expense/expense-modals";
import ExpenseStats from "@/components/expense/expense-stats";
import ExpenseTable from "@/components/expense/expense-table";
import { Button } from "@/components/ui/button";
import { Toast } from "@/components/ui/toast";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/finance/expenses")({
  component: ExpensesPage,
});

function ExpensesPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <ExpenseModals />
      <Toast name="clipboard" message="Copy to clipboard" autoClose={2000} />

      <div className="max-w-6xl mx-auto">
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-semibold"> {t("Expenses")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_expense");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add an expense")}
          </Button>
        </header>
        <ExpenseStats />
        <div className="mt-4"></div>
        <ExpenseTable />
      </div>
    </>
  );
}
